import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { Validators } from '@angular/forms';
import { InputComponent } from '../input/input.component';
import { CallbackValidator } from '../validator/callback-validator';

@Component({
    selector: 'app-key',
    templateUrl: './key.component.html',
    styleUrls: ['./key.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class KeyComponent extends InputComponent {
    validate = input<(value: any) => boolean>();
    parentModel = input<any>();
    clear = output<void>();

    protected getValidators(): any[] {
        const meta = this.meta();
        const validators = super.getValidators();

        const validate = this.validate();
        if (!!validate) {
            validators.push(CallbackValidator(validate));
        }

        if (meta) {
            if (meta.pattern) {
                validators.push(Validators.pattern(meta.pattern));
            }
        }

        return validators;
    }

    public onClear() {
        this.formControl()?.setValue('')
        this.clear.emit();
    }
}
